//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { mapActions } from "vuex";
export default {
  data() {
    return {
      jobs: [],
      pagination: {
        rowsPerPage: 10, 
        sortBy: "Id",
        descending: true,
      },
 
      columns: [
        {
          name: "Id",
          align: "left",
          label: "#",
          field: "id",
          sortable: true,
        },
        {
          name: "Name",
          align: "left",
          label: "Navn",
          field: "name",
          sortable: true,
        },
        {
          name: "CreatedAt",
          align: "left",
          label: "Dato opprettet",
          field: "createdAt",
          sortable: true,
          format: val => new Date(val).toLocaleString() 
        },
        {
          name: "Message",
          align: "left",
          label: "Melding",
          field: "message",
          sortable: true,          
        },
        {
          name: "Status",
          align: "left",
          label: "Status",
          field: "status",
          sortable: true,
          format: val => {
            const statusMap = {
                0: 'I kø',
                1: 'Under behandling',
                2: 'Vellykket',
                3: 'Planlagt',
                4: 'Feilet'
            };
            return statusMap[val] || 'Unknown';  // Translates status number to enum name
            }
        }
      ]
    };
  },
  async created() {    
        this.jobs = await this.getJobs();
  },
  computed: {},
  methods: {
    ...mapActions("main", [
      "getJobs",
    ]),



  }
};
